import React from "react";
import { useLang } from "@/context/LanguageContext";
import { SITE } from "@/config/site";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-display text-2xl text-[#1A2E24] mb-3">{title}</h2>
    <div className="text-[#3B5245] leading-relaxed space-y-3">{children}</div>
  </div>
);

const Privatliv = () => {
  const { lang } = useLang();
  const en = lang === "en";
  return (
    <section className="bg-[#F7F5F0]" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-32 pb-24">
        <p className="text-xs uppercase tracking-[0.3em] text-[#5C7567] mb-4">
          {en ? "Privacy" : "Privatliv"}
        </p>
        <h1 className="font-display text-4xl sm:text-5xl text-[#1A2E24]">
          {en ? "Privacy Policy" : "Privatlivspolitik"}
        </h1>
        <p className="mt-6 text-[#5C7567] leading-relaxed">
          {en
            ? "This page explains how Lotusgruppen processes the information you choose to submit through the website's contact form."
            : "Denne side beskriver, hvordan Lotusgruppen behandler de oplysninger, du selv vælger at indsende via hjemmesidens kontaktformular."}
        </p>

        <Section title={en ? "What information you submit" : "Hvilke oplysninger du indsender"}>
          <p>
            {en
              ? "When you use the contact form, we receive the contact details you enter yourself (such as name, email, phone, organisation) and the message you write."
              : "Når du bruger kontaktformularen, modtager vi de kontaktoplysninger, du selv indtaster (fx navn, e-mail, telefon, organisation), samt den besked, du skriver."}
          </p>
        </Section>

        <Section title={en ? "Purpose" : "Formål"}>
          <p>
            {en
              ? "We process the information solely to respond to and handle your enquiry and any subsequent dialogue."
              : "Vi behandler oplysningerne alene for at kunne besvare og håndtere din henvendelse og en eventuel efterfølgende dialog."}
          </p>
        </Section>

        <Section title={en ? "Storage and email delivery" : "Opbevaring og e-maillevering"}>
          <p>
            {en
              ? "Your message is stored in the database used to operate the website, and a notification is delivered to Lotusgruppen through the email provider we use. Technical events are logged to operate the service reliably, without the free-text content of your message."
              : "Din besked gemmes i den database, der anvendes til at drive hjemmesiden, og der leveres en notifikation til Lotusgruppen gennem den e-mailleverandør, vi anvender. Tekniske hændelser registreres for at drive tjenesten stabilt – uden fritekstindholdet i din besked."}
          </p>
        </Section>

        <Section title={en ? "Sensitive data" : "Følsomme oplysninger"}>
          <p className="rounded-xl border border-[#C47C5D]/40 bg-[#C47C5D]/10 p-4 text-[#1A2E24]">
            {en
              ? "Please do not send CPR numbers, health information, sentence data or other sensitive personal data about a citizen's case through the contact form. Specific cases are handled afterwards through an agreed, secure form of communication."
              : "Send ikke CPR-numre, helbredsoplysninger, domsoplysninger eller andre følsomme personoplysninger om en borgersag gennem kontaktformularen. Konkrete sager håndteres efterfølgende gennem en aftalt og sikker kommunikationsform."}
          </p>
        </Section>

        <Section title={en ? "Questions" : "Spørgsmål"}>
          <p>
            {en ? "If you have questions, contact us at " : "Har du spørgsmål, kan du kontakte os på "}
            <a href={`mailto:${SITE.contact.email}`} className="text-[#2D5A3F] underline">{SITE.contact.email}</a>
            {" "}{en ? "or" : "eller"}{" "}
            <a href={`tel:${SITE.contact.phoneRaw}`} className="text-[#2D5A3F] underline">{SITE.contact.phone}</a>.
          </p>
        </Section>

        <p className="mt-12 text-xs text-[#5C7567]">
          {en
            ? "This text describes the actual technical setup and is pending final legal review before go-live."
            : "Denne tekst beskriver den faktiske tekniske løsning og afventer endelig juridisk gennemgang før go-live."}
        </p>
      </div>
    </section>
  );
};

export default Privatliv;
